import DashboardGuestResource, { Data as ResourceData } from '@quickService/DashboardGuestResource';
import { useEffect, useState } from 'react';
import useSWR from 'swr';

export function useGuestResource(eventId: string) {
  const [guestResource, setGuestResource] = useState<ResourceData>({
    guest_actual_num: 0,
    guest_num_limit: 10,
  });

  const { data, mutate } = useSWR(
    {
      url: '/v2/activities/dashboard/guest/resource',
      event_id: eventId,
    },
    async ({ event_id }) => {
      const resp = await DashboardGuestResource({ event_id });
      if (resp?.code === 0 && resp?.data) {
        return resp.data;
      }
    },
  );

  useEffect(() => {
    if (data) {
      setGuestResource(data);
    }
  }, [data]);

  return {
    guestResource,
    mutate,
  };
}
